module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "mask-group.5741a9c6.png";